<template class="tee">
  <div>
    <div class="success__wrap" v-if="success">
      <span class="success">{{ successMessage }}</span>
      <svgicon icon="cancel" class="success__icon"></svgicon>
    </div>
    <div class="dashboard__manageListing-top">
      <router-link
        :to="`/listing?page=${curPage}`"
        tag="p"
        class="dashboard__back"
        >Back</router-link
      >
      <div v-if="listingData" class="dashboard__manageListing-action">
        <button
          class="alt_btn"
          v-if="
            listingData.status == 'awaiting approval' ||
              listingData.status == 'updated'
          "
          type="button"
          @click="approveListing(listingData.id)"
        >
          Publish
        </button>
        <!-- <button
          class="alt_btn"
          type="button"
          :disabled="!amount"
          @click="addBooking"
        >
          <svgicon
            icon="spinner"
            v-if="bookingLoader"
            class="button__loader_blue"
          ></svgicon>
          Save changes
        </button> -->

        <b-dropdown
          id="dropdown-right"
          right
          toggle-class="text-decoration-none alt_btn"
          no-caret
          v-if="listingData.approval_status != 'disapproved'"
        >
          <template v-slot:button-content>
            <svgicon
              icon="table-menu"
              class="dashboard__manageListing-action-icon"
            ></svgicon>
          </template>

          <b-dropdown-item-button
            v-if="
              listingData.status == 'awaiting approval' ||
                listingData.status == 'updated'
            "
            @click="toggleDisapprovemodal"
            >Decline</b-dropdown-item-button
          >
          <b-dropdown-item
            v-if="listingData.status == 'published'"
            @click="deactivateListing(listingData.id)"
            >Deactivate</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              listingData.status == 'deactivated' ||
                listingData.status == 'unavailable'
            "
            @click="activateListing(listingData.id)"
            >{{
              listingData.status === "unavailable"
                ? "Make Available"
                : "Activate"
            }}
          </b-dropdown-item>

          <b-dropdown-item @click="toggleAddComment"
            >Add comment</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <p
      class="listing__status"
      style="margin-bottom: 48px"
      v-if="listingData"
      :class="[
        { pending: listingData.status == 'pending' },
        { updated: listingData.status == 'updated' },
        { declined: listingData.status == 'declined' },
        { published: listingData.status == 'published' },
        {
          awaiting_approval: listingData.status == 'awaiting approval'
        },
        { unavailable: listingData.status == 'unavailable' },
        { deactivated: listingData.status == 'deactivated' }
      ]"
    >
      {{ listingData.status | capitalize }}
    </p>

    <div class="dashboard__manageListing-row">
      <div class="dashboard__manageListing-individual">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">
            Space Details
          </p>
        </div>
        <div
          class="dashboard__manageListing-individual-content"
          v-if="listingData != null"
        >
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">Host name</p>
            <router-link
              tag="p"
              :to="'/member-details/' + listingData.user_id"
              class="dashboard__manageListing-individual-text"
              style="cursor: pointer"
            >
              {{ listingData.host_name }}
            </router-link>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">Name</p>
            <p class="dashboard__manageListing-individual-text">
              {{ listingData.title }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              Property type
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{ listingData.property_type.name | capitalize }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              Furnishing status
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{
                listingData.is_furnished
                  ? "Furnished"
                  : "Unfurnished" | capitalize
              }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">Space type</p>
            <p class="dashboard__manageListing-individual-text">
              {{ listingData.listing_type | capitalize }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              Subcription type
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{
                listingData.sub_type_code === "beachHouse"
                  ? "Beach House"
                  : listingData.sub_type_code
              }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">Location</p>
            <p
              class="
                dashboard__manageListing-individual-text
                dashboard__manageListing-individual-location
              "
              @click="showMap"
              :title="listingData.property_address"
            >
              {{ listingData.property_address }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              House number
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{ listingData.house_no }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              Created at
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{ formatDate(listingData.created_at) }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              Updated at
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{ formatDate(listingData.updated_at) }}
            </p>
          </div>
          <div class="dashboard__manageListing-individual-info">
            <p class="dashboard__manageListing-individual-title">
              Moratorium period
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{ listingData.moratoriumPeriod }} Days
            </p>
          </div>
        </div>
      </div>
      <div class="dashboard__manageListing-individual">
        <div class="dashboard__manageListing-individual-header row">
          <p class="dashboard__manageListing-individual-heading col">
            Pricing
          </p>
          <p
            class="dashboard__manageListing-individual-heading col text-center"
          >
            Current Price
          </p>
          <p
            class="dashboard__manageListing-individual-heading col text-center"
          >
            Updated Price
          </p>
        </div>
        <div
          class="dashboard__manageListing-individual-content"
          :class="listingData.listing_type == 'shared' && 'wrapper'"
          v-if="listingData != null"
        >
          <!-- Entire Pricing -->
          <div
            v-if="
              listingData.listing_type == 'entire' ||
                listingData.listing_type == 'both'
            "
            style="margin-bottom: 20px"
          >
            <div
              class="pricing"
              v-for="(plan, i) in listingPriceDetails.subPlan"
              :key="i"
            >
              <p class="pricing__header">
                {{ listingData.listing_type | capitalize }} /
                {{ plan | capitalize }}
              </p>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Rent</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "rent",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "rent",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Commision</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "computed_commission",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "computed_commission",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Service Charge</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "service_charge",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "service_charge",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Discount</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "percentageDiscount",
                      i
                    ) | convertToPercentage
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "percentageDiscount",
                      i
                    ) | convertToPercentage
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Withholding Tax</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "withholdingTax",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "withholdingTax",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Agreement/Legal fee:</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "legalFee",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "legalFee",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Agency fee:</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "agencyFee",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "agencyFee",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
              <div class="pricing__wrap">
                <p class="pricing__wrap-item title">Security Deposit</p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.currentPrice,
                      plan,
                      "securityDeposit",
                      i
                    ) | currencyFormatter
                  }}
                </p>
                <p class="pricing__wrap-item figure">
                  {{
                    getValues(
                      listingPriceDetails.updatedPrice,
                      plan,
                      "securityDeposit",
                      i
                    ) | currencyFormatter
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- Shared Pricing -->
          <div
            v-if="
              listingData.listing_type == 'shared' ||
                listingData.listing_type == 'both'
            "
            style="margin-bottom: 20px"
          >
            <div
              v-for="roomPrices in listingPriceDetails.bedrooms"
              :key="roomPrices.id"
              class="accordion individual__pricing"
              role="tablist"
            >
              <b-card
                v-for="(plan, i) in listingPriceDetails.subPlan"
                :key="i"
                no-body
                class="mb-1"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="
                      'accordion-' + accordionTab(roomPrices.prices, i)
                    "
                    variant="info"
                  >
                    {{ roomPrices.name | capitalize }} /
                    {{ plan | capitalize }}
                  </b-button>
                  <span
                    class="deactivate-btn"
                    @click="() => deactivateSharedSpace(roomPrices.id)"
                    >Deactivate</span
                  >
                </b-card-header>
                <b-collapse
                  :id="`accordion-${accordionTab(roomPrices.prices, i)}`"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <div class="pricing shared">
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Rent</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "rent"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "rent"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Commision</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "computed_commission"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "computed_commission"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Service Charge</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "service_charge"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "service_charge"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Discount</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "percentageDiscount"
                            ) | convertToPercentage
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "percentageDiscount"
                            ) | convertToPercentage
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Withholding Tax</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "withholdingTax"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "withholdingTax"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">
                          Agreement/Legal fee:
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "legalFee"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "legalFee"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Agency fee:</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "agencyFee"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "agencyFee"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                      <div class="pricing__wrap">
                        <p class="pricing__wrap-item title">Security Deposit</p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.currentPrice,
                              plan,
                              "securityDeposit"
                            ) | currencyFormatter
                          }}
                        </p>
                        <p class="pricing__wrap-item figure">
                          {{
                            getValues(
                              roomPrices.prices.updatedPrice,
                              plan,
                              "securityDeposit"
                            ) | currencyFormatter
                          }}
                        </p>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard__manageListing-row">
      <div class="dashboard__manageListing-individual">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">Services</p>
        </div>
        <div
          v-if="listingData != null"
          class="dashboard__manageListing-individual-content"
        >
          <div
            v-if="listingData.serviceCharge != null"
            class="dashboard__manageListing-individual-info"
          >
            <p class="dashboard__manageListing-individual-title">
              Total service charge per month
            </p>
            <p class="dashboard__manageListing-individual-text">
              ₦
              {{
                new Intl.NumberFormat().format(
                  Number(listingData.serviceCharge)
                )
              }}
            </p>
          </div>
          <div
            v-if="listingData.power_duration != null"
            class="dashboard__manageListing-individual-info"
          >
            <p class="dashboard__manageListing-individual-title">
              Power duration
            </p>
            <p class="dashboard__manageListing-individual-text">
              {{ listingData.power_duration }} hrs
            </p>
          </div>
          <div
            v-if="listingData.maintenance_option != null"
            class="dashboard__manageListing-individual-info"
          >
            <p class="dashboard__manageListing-individual-title">Cleaning</p>
            <p class="dashboard__manageListing-individual-text">
              {{
                listingData.maintenance_option.provide_cleaning
                  ? "I will provide cleaning"
                  : "Spleet should provide cleaning"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="dashboard__manageListing-individual-image">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">Images Text</p>
        </div>
        <div class="dashboard__manageListing-individual-content-image">
          <div
            v-for="(bedroom, index) in listOfBedrooms"
            :key="index"
            class="dashboard-room-container"
          >
            <h4>{{ bedroom.name }}</h4>
            <div
              class="dashboard__manageListing-individual-image-block multi-bedroom-image"
            >
              <div
                class="dashboard__manageListing-individual-image-block"
                v-for="(image, index) in bedroom.images"
                @click="() => toggleDefaultImageModal(bedroom, image)"
                :key="index"
              >
                <img
                  class="bedroom-image-container"
                  :src="image.image_path"
                  @click="showImg(index)"
                />
                <div class="active-bedroom-cover" v-if="image.coverImage">
                  Active
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4>Common Area</h4>

            <div class="dashboard-image-container">
              <div
                class="dashboard__manageListing-individual-image-block"
                v-for="(image, index) in commonArea"
                @click="() => toggleDefaultImageModal(null, image)"
                :key="index"
              >
                <img
                  class="bedroom-image-container"
                  :src="image.image_path"
                  @click="showImg(index), (commonAreaModal = true)"
                />
                {{ image.coverImage ? "Active" : "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard__manageListing-row">
      <div class="dashboard__manageListing-individual">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">Description</p>
        </div>
        <div
          class="dashboard__manageListing-individual-content"
          v-if="listingData != null"
        >
          <p class="dashboard__manageListing-individual-title description">
            {{ listingData.description }}
          </p>
        </div>
      </div>
      <div class="dashboard__manageListing-individual-image">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">
            Processing Fee
          </p>
        </div>
        <div class="dashboard__manageListing-individual-content-amenities">
          <div class="listing">
            <p class="dashboard__manageListing-individual-title">
              Processing fee paid by
            </p>
            <p
              v-if="listingData"
              class="listing__right dashboard__manageListing-individual-title"
            >
              {{ listingData.hostPayCommission ? "Host" : "Member" }}
            </p>
          </div>
          <div class="listing">
            <p>Edit Processing fee:</p>

            <div class="listing__right">
              <div v-if="commissions.length" class="listing__right">
                <div
                  v-for="(plan, i) in commissions"
                  class="listing__right-item"
                  :key="i"
                >
                  <p>{{ plan.plan | capitalize }} processing fee</p>
                  <div class="input__wrap percentage">
                    <input
                      class="dashboard__input percentage__input"
                      type="number"
                      name=""
                      id=""
                      v-model="plan.commission"
                    />
                    <p class="percentage__sign">%</p>
                  </div>
                </div>
              </div>
              <div v-if="commissions.length === 0" class="listing__right">
                <div
                  v-for="(plan, i) in sortedItems(listingPriceDetails.subPlan)"
                  class="listing__right-item"
                  :key="i"
                >
                  <p>{{ plan | capitalize }} commission</p>
                  <div class="input__wrap percentage">
                    <input
                      class="dashboard__input percentage__input"
                      type="number"
                      name=""
                      id=""
                      v-model="commissions[plan]"
                    />
                    <p class="percentage__sign">%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="listing action">
            <button class="cta_btn dashboard__btn" @click="addCommission">
              <svgicon
                icon="spinner"
                v-if="bookingLoader"
                class="button__loader_blue"
              ></svgicon
              >Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard__manageListing-row">
      <div class="dashboard__manageListing-individual-image">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">Amenities</p>
        </div>
        <div
          class="dashboard__manageListing-individual-content-amenities"
          v-if="listingData != null"
        >
          <div
            class="amenities-grid"
            v-for="(bedroom, index) in listingData.bedrooms"
            :key="index"
          >
            <div v-for="(amenity, index) in bedroom.amenities" :key="index">
              <p class="dashboard__manageListing-amenities">
                <img
                  :src="amenity.amenity_name ? amenity.amenity_name.icon : ''"
                  :alt="
                    amenity.amenity_name
                      ? amenity.amenity_name.name
                      : '' + ' icon'
                  "
                  class="dashboard__manageListing-amenities-icon img-fluid"
                />
                <span class="dashboard__manageListing-amenities-name">{{
                  amenity.amenity_name ? amenity.amenity_name.name : ""
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard__manageListing-individual-image">
        <div class="dashboard__manageListing-individual-header">
          <p class="dashboard__manageListing-individual-heading">
            Verification
          </p>
        </div>
        <div class="dashboard__manageListing-individual-content-amenities">
          <div class="verification-box">
            <p>Mark as verified</p>
            <Toogle
              :value="toggleStatus"
              @toggle="value => handleToggle(value)"
            />
          </div>
        </div>
      </div>
    </div>

    <vue-easy-lightbox
      :visible="visible"
      :imgs="image"
      :index="index"
      @hide="handleHide"
      :moveDisabled="true"
    >
      <template slot="toolbar" slot-scope="props">
        <button class="d-none" @click="props.toolbarMethods.zoomIn">
          zoom in
        </button>
        <button class="d-none" @click="props.toolbarMethods.zoomOut">
          zoom out
        </button>
        <button class="d-none" @click="props.toolbarMethods.rotateLeft">
          Anticlockwise rotation
        </button>
        <button class="d-none" @click="props.toolbarMethods.rotateRight">
          clockwise rotation
        </button>
      </template>
    </vue-easy-lightbox>

    <vue-easy-lightbox
      :visible="visible"
      :imgs="media"
      :index="index"
      @on-prev-click="next"
      @on-next-click="prev"
      @hide="hideModal"
    >
      <template v-slot:toolbar>
        <button
          class="cta_btn dashboard__btn absolute left-0 right-0 mx-auto"
          @click="onDefaultImageSetup()"
          :disabled="imageUpdateLoading"
        >
          <svgicon
            v-if="imageUpdateLoading"
            icon="spinner"
            class="button__loader"
          ></svgicon>
          Set as default image
        </button>
      </template>
    </vue-easy-lightbox>

    <!-- Disapprove modal -->
    <div
      class="app-modal"
      :class="[showDisapproveModal ? 'show' : 'hide']"
      @click="showDisapproveModal = false"
    >
      <div class="app-modal-content" @click.stop>
        <p class="warning__title">Decline</p>
        <div class="form__group w-100">
          <label for class="form__label"
            >Reason for declining this listing</label
          >
          <textarea
            class="listing__textarea mb-0 p-3 w-100"
            v-model="reasonNote"
          ></textarea>
        </div>
        <div class="form__action-wrap">
          <span @click="toggleDisapprovemodal" class="form__back">Cancel</span>
          <button
            class="cta_btn dashboard__btn d-inline"
            :class="[{ disabled_btn: reasonNote == null || declineLoading }]"
            @click="declineListing(listingData.id)"
            :disabled="reasonNote == null || declineLoading"
          >
            <svgicon
              v-if="declineLoading"
              icon="spinner"
              class="button__loader"
            ></svgicon>
            Decline
          </button>
        </div>
      </div>
    </div>
    <!-- Disapprove modal -->

    <!-- Add comment modal -->
    <div
      class="app-modal"
      :class="[showAddComment ? 'show' : 'hide']"
      @click="showAddComment = false"
    >
      <div class="app-modal-content" @click.stop>
        <p class="warning__title">Add comment</p>
        <div class="form__group w-100">
          <label for class="form__label">Add a good to know comment</label>
          <div class="form__info" style="max-width: 100%">
            Comments are displayed as list item. Kindly list individual
            item/sentence as shown below with each sentence separated by ';'
            <pre style="white-space: pre-wrap; margin-top: 10px" class="mb-0">
          This space is fine die.<b>;</b>If you live in this space you will enjoy.<b>;</b>No wahala with agent.</pre
            >
          </div>
          <textarea
            class="listing__textarea mb-0 p-3 w-100"
            v-model="comment"
          ></textarea>
        </div>
        <div class="form__action-wrap">
          <button
            class="cta_btn dashboard__btn"
            @click="addComment(listingData.id)"
            :disabled="comment == null || addCommentLoading"
          >
            <svgicon
              v-if="addCommentLoading"
              icon="spinner"
              class="button__loader"
            ></svgicon>
            Add comment
          </button>
        </div>
      </div>
    </div>

    <!-- Map modal -->
    <div
      class="bedroom__phototip-modal"
      :class="[showMapModal ? 'show' : 'hide']"
      @click="showMapModal = false"
    >
      <div
        class="
          bedroom__phototip-modal-content
          dashboard__manageListing-extraCharge-modal
        "
        @click.stop
      >
        <p
          v-if="listingData != null"
          class="dashboard__manageListing-individual-text text-left mb-4"
        >
          {{ listingData.property_address }}
        </p>
        <div id="map" class="location__map w-100"></div>
      </div>
    </div>

    <loader :loader="listingLoader"></loader>
  </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import {
  getListingDetail,
  getListing,
  approveListing,
  declineListing,
  activateListing,
  deactivateListing,
  updateCoverImage,
  addComment,
  deactivateASharedSpace,
  addCommissionFee,
  updateCommissionFee,
  verificationStatus
} from "../../../services/listing";
import { formatReadbleDate } from "../../utils/index";
import loader from "../resuables/loader";
import Toogle from "../resuables/toggle.vue";
let Gmap;
let Gmarker;
export default {
  name: "listingDetails",
  components: {
    VueEasyLightbox,
    loader,
    Toogle
  },
  data() {
    return {
      index: 0,
      visible: false,
      commonAreaModal: false,
      comment: null,
      addCommentLoading: false,
      imageUpdateLoading: false,
      showDefaultImageModal: false,
      showAddComment: false,
      listingImages: [],
      currency: {
        prefix: "₦ ",
        numeral: true,
        numeralPositiveOnly: true,
        noImmediatePrefix: true,
        rawValueTrimPrefix: true,
        numeralIntegerScale: 9,
        numeralDecimalScale: 2
      },
      percentage: {
        numeralPositiveOnly: true,
        rawValueTrimPrefix: true,
        numeralIntegerScale: 9,
        numeralDecimalScale: 2
      },
      listingId: this.$route.params.id,
      listingData: null,
      listingLoader: false,
      success: false,
      successMessage: "",
      showDisapproveModal: false,
      reasonNote: null,
      declineLoading: false,
      showMapModal: false,
      generalAmenities: [],
      diningRoomAmenities: [],
      kitchenAmenities: [],
      livingRoomAmenities: [],
      commonArea: [],
      listOfBedrooms: [],
      selectedBedroom: null,
      selectedRoomImage: {},
      pricingArray: [],
      listingPriceDetails: {},
      amount: null,
      percent: 0,
      bookingLoader: false,
      booking: null,
      commissions: [],
      showCommissions: false,
      toggleStatus: false
    };
  },
  methods: {
    async addCommission() {
      try {
        this.bookingLoader = true;
        let response;
        if (this.commissions.length) {
          const payloaded = {
            propertyListingId: this.listingId,
            commissions: this.commissions
          };
          response = await updateCommissionFee(payloaded);
        } else {
          const formattedCommissions = Object.entries(this.commissions).map(
            ([plan, commission]) => ({
              commission: parseFloat(commission), // Convert commission to number
              plan
            })
          );
          const payload = {
            propertyListingId: this.listingId,
            commissions: formattedCommissions
          };
          response = await addCommissionFee(payload);
        }
        if (response.statusCode == 200 || response.statusCode == 201) {
          this.getListing();
          this.$notification.success({
            message: response.message
          });
        } else {
          this.$notification.error({
            message: response.data.message
          });
        }
      } catch (error) {
        this.$notification.error({
          message: data.data.message
        });
      } finally {
        this.bookingLoader = false;
      }
    },
    async deactivateSharedSpace(apartmentId) {
      deactivateASharedSpace(apartmentId)
        .then(data => {
          if (data.statusCode === 200) {
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: err.response.data.message
          });
        });
    },
    accordionTab(price, i) {
      return price.currentPrice[i] ? price.currentPrice[i].id : "";
    },
    getValues(roomPrices, plan, type, pIndex) {
      let priceByPlan;
      if (!roomPrices || !Array.isArray(roomPrices)) {
        this.$notification.error({
          message: "Error: Room Prices is not an array",
          description: roomPrices
        });
        return 0; // Return a default value instead of crashing
      }
      priceByPlan = roomPrices.find((el, index) => index === pIndex);

      switch (type) {
        case "rent":
          return priceByPlan ? priceByPlan.amount : 0;
        case "computed_commission":
          return priceByPlan ? priceByPlan.computed_commission : 0;
        case "service_charge":
          return priceByPlan ? priceByPlan.service_charge : 0;
        case "percentageDiscount":
          return priceByPlan ? priceByPlan.percentageDiscount : 0;
        case "withholdingTax":
          return priceByPlan ? priceByPlan.withholdingTax : 0;
        case "securityDeposit":
          return priceByPlan ? priceByPlan.securityDeposit : 0;
        case "agencyFee":
          return priceByPlan ? priceByPlan.agencyFee : 0;
        case "legalFee":
          return priceByPlan ? priceByPlan.legalFee : 0;
        default:
          return priceByPlan ? priceByPlan.computed_commission : 0;
      }
    },
    getPricing() {
      let subPlan = [];
      if (this.listingData.sub_type_code === "RLS") {
        subPlan = this.listingData.subscription_option.subscription_plan.map(
          sub => sub.plan
        );
      } else if (this.listingData.sub_type_code === "beachHouse") {
        subPlan = this.listingData.prices.map(price => price.category);
      } else if (this.listingData.sub_type_code === "DLS") {
        subPlan = ["daily"];
      }
      const newPriceArray = [];
      if (
        this.listingData.listing_type === "entire" ||
        this.listingData.listing_type === "both"
      ) {
        this.listingPriceDetails = {
          subPlan,
          currentPrice: this.listingData.prices,
          updatedPrice: this.listingData.updatedPrice
        };
      }
      if (
        this.listingData.listing_type === "shared" ||
        this.listingData.listing_type === "both"
      ) {
        const { bedrooms, updatedPrice } = this.listingData;
        this.listingPriceDetails = {
          bedrooms,
          subPlan
        };
        this.listingPriceDetails.bedrooms = this.listingPriceDetails.bedrooms.map(
          bedroom => {
            const price = {};
            const bedroomById = updatedPrice.filter(
              prc => prc.bedroom_id === bedroom.id
            );
            price.currentPrice = bedroom.prices;
            price.updatedPrice = bedroomById;
            bedroom.prices = price;
            return bedroom;
          }
        );
      }
      this.pricingArray = newPriceArray;
    },
    next(_, newIndex) {
      this.index = newIndex;
      if (this.commonAreaModal) {
        this.selectedRoomImage = this.commonArea[this.index];
      }
    },
    prev(_, newIndex) {
      this.index = newIndex;
      if (this.commonAreaModal) {
        this.selectedRoomImage = this.commonArea[this.index];
      }
    },

    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    hideModal() {
      this.visible = false;
      this.selectedBedroom = null;
      this.selectedBedroom = null;
      this.index = null;
      this.commonAreaModal = false;
    },
    toggleAddComment() {
      this.showAddComment = !this.showAddComment;
    },
    toggleDisapprovemodal() {
      this.showDisapproveModal = !this.showDisapproveModal;
    },
    toggleDefaultImageModal(room, image) {
      this.selectedBedroom = room;
      this.selectedRoomImage = image;
    },
    onDefaultImageSetup() {
      this.imageUpdateLoading = true;
      const payload = {
        imageId: this.commonAreaModal
          ? this.selectedRoomImage.id
          : this.selectedBedroom.images[this.index].id,
        coverImage: true
      };

      if (this.selectedBedroom && this.listingData.listing_type === "shared") {
        payload.bedroomId = this.selectedBedroom.id;
        payload.listingType = "shared";
      }

      if (!this.selectedBedroom && this.listingData.listing_type === "shared") {
        payload.listingType = "entire";
      }

      if (
        this.selectedBedroom &&
        (this.listingData.listing_type === "entire" ||
          this.listingData.listing_type === "both")
      ) {
        payload.bedroomId = this.selectedBedroom.id;
        payload.listingType = "shared";
      }

      if (
        !this.selectedBedroom &&
        (this.listingData.listing_type === "entire" ||
          this.listingData.listing_type === "both")
      ) {
        payload.listingType = "entire";
      }

      updateCoverImage(this.listingId, payload)
        .then(res => {
          this.imageUpdateLoading = false;
          this.hideModal();
          this.getListing();
          this.$notification.success({
            message: "Default Image",
            description: res.message
          });
        })
        .catch(err => {
          this.imageUpdateLoading = false;
          this.getListing();
          this.$notification.error({
            message: "Setting default image failed",
            description: err.response.data.message
          });
        });
    },
    formatAttachmentNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    showMap() {
      this.showMapModal = !this.showMapModal;
      const lat = Number(this.listingData.latitude);
      const lng = Number(this.listingData.longitude);
      const latlng = {
        lat,
        lng
      };
      let mapOptions = {
        center: latlng,
        zoom: 14
      };
      let mapDom = document.getElementById("map");
      Gmap = new google.maps.Map(mapDom, mapOptions);
      this.createMarker();
    },
    createMarker() {
      const lat = Number(this.listingData.latitude);
      const lng = Number(this.listingData.longitude);
      const latlng = {
        lat,
        lng
      };
      let markerOptions = {
        position: latlng,
        map: Gmap,
        animation: google.maps.Animation.BOUNCE,
        clickable: true,
        draggable: false
      };
      Gmarker = new google.maps.Marker(markerOptions);
    },
    getListing() {
      this.listingImages = [];
      this.listingLoader = true;
      getListingDetail(this.listingId)
        .then(data => {
          if (data.statusCode == 200) {
            this.listingLoader = false;
            this.listingData = data.data;
            this.toggleStatus = data.data.verifiedBySpleet === "verified";
            this.comment = data.data.good_to_know;
            this.generalAmenities = this.listingData.bedrooms.amenities.filter(
              amenity => {
                return amenity.amenity_category.name == "General";
              }
            );
            this.diningRoomAmenities = this.listingData.bedrooms.amenities.filter(
              amenity => {
                return amenity.amenity_category.name == "Dinning Room";
              }
            );

            this.kitchenAmenities = this.listingData.bedrooms.amenities.filter(
              amenity => {
                return amenity.amenity_category.name == "Kitchen";
              }
            );

            this.livingRoomAmenities = this.listingData.bedrooms.amenities.filter(
              amenity => {
                return amenity.amenity_category.name == "Living Room";
              }
            );
            this.commissions = this.listingData.commissions;
          }
        })
        .catch(err => {
          this.listingLoader = false;
          return err;
        });
    },
    getImages() {
      this.listOfBedrooms = [];
      this.commonArea = [];
      if (this.listingData != null) {
        this.listingData.bedrooms.forEach(el => {
          this.listOfBedrooms.push(el);
        });
        this.listingData.images
          ? this.listingData.images.forEach(el => {
              this.commonArea.push(el);
            })
          : (this.commonArea = []);
      }
    },
    approveListing(id) {
      approveListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Approved!",
              description: "You have successfully approved a listing"
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    declineListing(id) {
      this.declineLoading = true;
      const reasonNote = {
        decline_reason: this.reasonNote
      };
      declineListing(id, reasonNote)
        .then(data => {
          if (data.statusCode == 200) {
            this.declineLoading = false;
            this.showDisapproveModal = false;
            this.reasonNote = null;
            this.$notification.success({
              message: "Listing Declined!",
              description: "You have declined a listing"
            });
          } else {
            this.declineLoading = false;
            this.showDisapproveModal = false;
            this.reasonNote = null;
            this.$notification.error({
              message: "Error",
              description: "You are not authorized to perform this action"
            });
          }
          this.getListing();
        })
        .catch(err => {
          this.declineLoading = false;
          this.showDisapproveModal = false;
          return err;
        });
    },
    activateListing(id) {
      activateListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Activated!",
              description: "You have successfully activated a listing"
            });
          }
          this.getListing();
        })
        .catch(err => {
          return err;
        });
    },
    deactivateListing(id) {
      deactivateListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Deactivated!",
              description: "You have successfully deactivated a listing"
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    addComment(id) {
      this.addCommentLoading = true;
      const data = {
        comment: this.comment
      };

      addComment(id, data)
        .then(res => {
          this.addCommentLoading = false;
          if (res.statusCode === 200) {
            this.$notification.success({
              message: "Comment added!",
              description: "You have successfully added a good to know comment"
            });
            this.showAddComment = false;
            this.getListing();
          } else {
            this.showAddComment = false;
            this.$notification.error({
              message: "Error",
              description: res.data.message
            });
          }
        })
        .catch(err => {
          this.addCommentLoading = false;
          this.showAddComment = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    sortedItems(plans) {
      if (!Array.isArray(plans)) {
        plans = plans ? Object.values(plans) : [];
      }

      const inputOrder = ["monthly", "quarterly", "biannual", "yearly"];

      return plans
        .filter(plan => plan) // Remove any null or undefined values
        .sort((a, b) => {
          return inputOrder.indexOf(a) - inputOrder.indexOf(b);
        });
    },
    handleToggle(value) {
      if (value === true) {
        const body = {
          verifiedBySpleet: "verified"
        };
        verificationStatus(this.listingId, body)
          .then(res => {
            if (res.statusCode === 200) {
              this.$notification.success({
                message: "Space Verificated!",
                description: res.data.message
              });
              this.getListing();
            } else {
              this.$notification.error({
                message: "Error",
                description: res.data.message
              });
            }
          })
          .catch(err => {
            this.$notification.error({
              message: "Error!",
              description: err.response.data.message
            });
            return err;
          });
      } else {
        const body = {
          verifiedBySpleet: "unverified"
        };
        verificationStatus(this.listingId, body)
          .then(res => {
            if (res.statusCode === 200) {
              this.$notification.success({
                message: "Space Unverificated!",
                description: res.data.message
              });
              this.getListing();
            } else {
              this.$notification.error({
                message: "Error",
                description: res.data.message
              });
            }
          })
          .catch(err => {
            this.$notification.error({
              message: "Error!",
              description: err.response.data.message
            });
            return err;
          });
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    media() {
      if (this.selectedBedroom) {
        return this.selectedBedroom.images.map(image => image.image_path);
      } else return this.commonArea.map(img => img.image_path);
    },
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage() {
      return this.$route.query.page || 1;
    },
    image() {
      return this.listingImages.map(img => {
        return img;
      });
    }
  },
  watch: {
    listingData() {
      this.getImages();
      this.getPricing();
    },
    "listingData.verifiedBySpleet"(newVal) {
      this.toggleStatus = newVal === "verified";
    }
  },
  mounted() {
    this.getListing();
  }
};
</script>

<style lang="scss" scoped>
.pricing {
  margin-bottom: 20px;

  &__wrap {
    display: flex;

    &-item {
      flex: 1;
      width: 33%;

      &.title {
        font-size: 12px;
        line-height: 15px;
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 14px;
      }

      &.figure {
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }

  &__header {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.6);
  }

  &.shared {
    margin-bottom: 0 !important;
  }

  &:last-child {
    margin-bottom: 0 !important;
  }
}

.individual__pricing {
  margin-bottom: 30px;
}

.individual__pricing:last-child {
  margin-bottom: 0 !important;
}

.wrapper {
  padding: 15px !important;
}

.wrapper:last-child {
  padding-bottom: 0 !important;
}
</style>

<style>
.card {
  border: 1px solid #b1b7d6;
  border-bottom: 1px solid #b1b7d6 !important;
  border-radius: 4px !important;
}

.card-header {
  background: white;
  border-bottom: 1px solid #b1b7d6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header button {
  background: transparent !important;
  border: transparent;
  color: rgba(0, 0, 0, 0.6);
  text-align: left;
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

.deactivate-btn {
  color: #ea4335;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  padding-right: 6px;
}

.card-header button:hover {
  color: rgba(0, 0, 0, 0.6);
}

.card-header button:focus,
.card-header button:active {
  box-shadow: none !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.currency {
  height: 40px;
  border-radius: 4px;
  border: 1px solid #d0d4e6;
  max-width: 213px;
}

.amenities-grid {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px 12px;
}

/* .amenities-grid2 {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px 12px;
} */

.verification-box {
  display: flex;
  gap: 8px;
  p {
    font-size: 14px;
    font-weight: 400;
  }
}

.disabled_btn {
  pointer-events: none;
  cursor: not-allowed;
  background-color: rgb(210, 210, 222);
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/listingDetails.vue